/**
 * Application theme colors based on Unisoft brand
 */

export const COLORS = {
  // Primary colors (from logo)
  primary: {
    blue: '#3b82f6',    // Start of gradient (blue)
    purple: '#8b5cf6',  // Middle of gradient (purple)
    pink: '#ec4899',    // Middle-end of gradient (pink)
    rose: '#f43f5e',    // End of gradient (red/rose)
    cyan: '#06b6d4',    // Accent color
  },
  
  // Light versions for backgrounds
  light: {
    blue: '#eff6ff',
    purple: '#f5f3ff',
    pink: '#fdf2f8',
    rose: '#fff1f2',
    cyan: '#ecfeff',
  },
  
  // Dark versions for hover states
  dark: {
    blue: '#2563eb',
    purple: '#7c3aed',
    pink: '#db2777',
    rose: '#e11d48',
    cyan: '#0891b2',
  },
  
  // Gradient combinations
  gradients: {
    primary: 'linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899, #f43f5e)',
    header: 'linear-gradient(90deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)',
    button: 'linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899)',
    card: 'linear-gradient(145deg, rgba(59,130,246,0.1) 0%, rgba(139,92,246,0.1) 50%, rgba(236,72,153,0.1) 100%)',
  },
  
  // Neutral colors
  neutral: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },

  // Status colors
  status: {
    success: '#10b981',  // emerald-500
    warning: '#f59e0b',  // amber-500
    error: '#ef4444',    // red-500
    info: '#3b82f6',     // blue-500
  },
};

// Export tailwind class combinations
export const TAILWIND_CLASSES = {
  gradientText: 'bg-clip-text text-transparent bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500',
  gradientButton: 'bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 hover:from-blue-600 hover:via-purple-600 hover:to-pink-600 text-white',
  card: 'bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-200',
  cardHeader: 'text-lg font-semibold text-gray-800',
  pageTitle: 'text-2xl font-bold text-gray-800',
};

export default COLORS; 